import Entity from './entity'
export default class Appointment extends Entity<number>{
    appointmentTime: Date
    startTime: Date
    endTime: Date
    topic: string
    content: string
    meetingRoomId: number
    memberIds: Array<number>
    remark: string
    year: number
    month: number
    day: number
}